import React, { useRef } from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';

import { Navbar } from 'shared/layouts/LandingMarketPlace/ui/Navbar';
import { Content } from 'shared/layouts/LandingMarketPlace/ui/Content';
import { Footer } from 'shared/layouts/LandingMarketPlace/ui/Footer';
import LandingPhone1 from 'static/landing/landing-phone-1.webp';
import LandingBg1 from 'static/images/landingMarketPlace/bg1.webp';
import LandingBg2 from 'static/images/landingMarketPlace/bg2.webp';
import LandingBg3 from 'static/images/landingMarketPlace/bg3.webp';
import LandingBg4 from 'static/images/landingMarketPlace/bg4.webp';
import LandingBg5 from 'static/images/landingMarketPlace/bg5.webp';
import LandingBg6 from 'static/images/landingMarketPlace/bg6.webp';

export const LandingMarketPlaceLayout: React.FC = () => {
    const contactsRef = useRef(null);

    const telegramRef = useRef(null);
    const chatBotRef = useRef(null);
    const crmRef = useRef(null);

    const blockProps = {
        contactsRef: contactsRef,
        telegramRef: telegramRef,
        chatBotRef: chatBotRef,
        crmRef: crmRef,
    };

    return (
        <StyledLayout>
            <Navbar {...blockProps} />
            <Content {...blockProps} />
            <Footer contactsRef={contactsRef} />
        </StyledLayout>
    );
};

const StyledLayout = styled(Layout)`
    background-color: #ffffff;
    background-image: url(${LandingBg1}), url(${LandingBg2}), url(${LandingBg3}),
        url(${LandingBg4}), url(${LandingBg5}), url(${LandingBg6});
    background-size: 1045px 1202px, 1133px 1311px, 1101px 1140px, 1020px 1455px,
        425px 553px, 939px 1038px;
    background-repeat: no-repeat;
    background-position: calc(50% + 569px) -297px, calc(50% - 539px) 89px,
        calc(50% + 547px) calc(50% + 301px), calc(50% - 555px) calc(50% + 565px),
        calc(50% - 4px) calc(100% - 165px), calc(50% + 391px) calc(100% + 88px);

    //     background-position: calc(50% + 569px) -297px, calc(50% - 539px) 89px, calc(50% + 316px) 2400px, calc(50% + 316px) 1165px, calc(50% + 316px) 2165px, calc(50% + 316px) 3165px;

    @media (max-width: 992px) {
        // background-size: 260px 265px, 954px 961px;
        background-position: calc(50% + 10%) -297px, calc(50% - 10%) 89px,
            calc(50% + 247px) calc(50% + 301px),
            calc(50% - 455px) calc(50% + 465px),
            calc(50% - 4px) calc(100% - 165px),
            calc(50% + 191px) calc(100% + 88px);
    }

    // @media (max-width: 483px) {
    //     background-position: calc(50% + -2px) 419px, calc(50% + -19px) 138px !important;
    // }
    //background-size: cover;
`;
